import { Component, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { TranslationService } from 'src/app/shared/translations/services/translation.service';
import { StockMovementHistoryComponent } from '../stock-movement-history/stock-movement-history.component';
import { StockManagementComponent } from '../stock-management/stock-management.component';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss', '../../inventory-shared.scss'],
  standalone: false
})
export class InventoryComponent {
  @ViewChild(StockMovementHistoryComponent) stockMovementHistoryComponent: StockMovementHistoryComponent;
  @ViewChild(StockManagementComponent) stockManagementComponent: StockManagementComponent;

  public store = inject(Store);
  public router = inject(Router);
  public translationService = inject(TranslationService);
  tabs = [{ label: 'stockMovementHistoryText' }, { label: 'stockManagementText' }];
  selectedTabLabel = this.tabs[0].label;

  onTabChange(index: number): void {
    // Clear stock management form when moving away from it
    if (this.selectedTabLabel === 'stockManagementText' && index !== 1 && this.stockManagementComponent) {
      this.stockManagementComponent.clearForm();
    }

    this.selectedTabLabel = this.tabs[index].label;

    // Refresh stock movement history when that tab is clicked
    if (index === 0 && this.stockMovementHistoryComponent) {
      this.stockMovementHistoryComponent.refreshData();
    }

    // Refresh stock management form when that tab is clicked
    if (index === 1 && this.stockManagementComponent) {
      this.stockManagementComponent.refreshForm();
    }
  }
}
